export * from './useContactsBadgeConfig';
